import { DcBaseComponent } from '@deleteagency/dc';
import Scroller from 'general/js/scroller';
import { getCharCount, getWordCount, trimSpaces } from './utils';

export default class ExpandedText extends DcBaseComponent {
    static getNamespace() {
        return 'expanded-text';
    }

    static getRequiredRefs() {
        return ['content'];
    }

    onInit() {
        const defaultOptions = {
            useChars: false,
            wordsCount: 60,
            charsCount: 150,
            moreText: 'More...',
            lessText: 'Less',
        };
        this._options = Object.assign({}, defaultOptions, this.options);
        this._truncate(this.refs.content);
        this.scroller = null;
        this.scrollOffset = 0;
    }

    _ellipse(str, max, isChars = false) {
        const trimedSpaces = trimSpaces(str);

        if (isChars) {
            return (
                trimedSpaces
                    .split('')
                    .slice(0, max)
                    .join('') + '...'
            );
        }

        return (
            trimedSpaces
                .split(/\s+/)
                .slice(0, max)
                .join(' ') + '...'
        );
    }

    _truncate(el) {
        const numberWords = this._options.wordsCount;
        const numberOfChars = this._options.charsCount;
        const numberCount = numberWords || numberOfChars;
        const originalContent = el.innerHTML;

        const originalContentCount = this._options.useChars
            ? getCharCount(originalContent)
            : getWordCount(originalContent);

        this.originalContent = originalContent;

        if (numberCount < originalContentCount) {
            const truncateContent = this._ellipse(
                originalContent,
                numberCount,
                this._options.useChars ? true : false
            );
            this.truncatedContent = truncateContent;
            el.innerHTML = this.truncatedContent;
            this.expanded = false;
            this._createLink();
        }
    }

    _createLink() {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = this._options.moreText;
        button.className = 'prop-description__button';
        this.addListener(button, 'click', this._handleLinkClick);
        this.refs.content.after(button);
    }

    _getScrollOffset() {
        const { top } = this.element.getBoundingClientRect();
        return top;
    }

    _expand(target) {
        this.refs.content.innerHTML = this.originalContent;
        target.textContent = this._options.lessText;
        this.expanded = true;
        this.scrollOffset = this._getScrollOffset();
    }

    _collapse(target) {
        this.refs.content.innerHTML = this.truncatedContent;
        target.innerHTML = this._options.moreText;
        this.expanded = false;
    }

    _handleLinkClick = (e) => {
        this.element.classList.toggle('is-expanded');
        const target = e.currentTarget;
        if (!this.expanded) {
            this._expand(target);
        } else {
            const currentOffset = this._getScrollOffset();
            if (currentOffset !== this.scrollOffset) {
                this.scroller = new Scroller(this.element, {
                    duration: 500,
                    scrollOffset: this.scrollOffset,
                });
                this.scroller.scrollToTop().then(() => {
                    this._collapse(target);
                    this.scroller = null;
                });
            } else {
                this._collapse(target);
            }
        }
    };
}
